import {default as resize} from './resize';
import {default as scroll} from './scroll';

export default {resize, scroll};
